import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../constants/common'
import { ICON_HEIGHT_24, IconSpinner } from '../Icon'
import Text from '../Text'

import * as styles from './LoaderText.module.css'

function LoaderText({
  Icon = IconSpinner,
  className = styles.LoaderText,
  iconProps: { size: iconSize = ICON_HEIGHT_24, ...iconProps } = EMPTY_OBJECT,
  textProps: {
    isSecondary: textIsSecondary = true,
    ...textProps
  } = EMPTY_OBJECT,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <Icon {...iconProps} size={iconSize} />
      <Text {...textProps} isSecondary={textIsSecondary}>
        {t('Common.LoadingTextKey')}
      </Text>
    </div>
  )
}

export default LoaderText
